
import { defineComponent, PropType } from 'vue'
import DataPreparationSimpleDescriptor from '@/modules/workspace/dataPreparation/DataPreparationSimple/DataPreparationSimpleDescriptor.json'
import Calendar from 'primevue/calendar'
import Dropdown from 'primevue/dropdown'
import InputSwitch from 'primevue/inputswitch'
import MultiSelect from 'primevue/multiselect'
import Textarea from 'primevue/textarea'

import { ITransformation, ITransformationParameter } from '@/modules/workspace/dataPreparation/DataPreparation'
import { IDataPreparationColumn } from '@/modules/workspace/dataPreparation/DataPreparation'
import { createValidations } from '@/helpers/commons/validationHelper'
import useValidate from '@vuelidate/core'

export default defineComponent({
    name: 'data-preparation-simple',

    props: { readOnly: Boolean, col: String, columns: { type: Array as PropType<Array<IDataPreparationColumn>> }, transformation: {} as PropType<ITransformation<ITransformationParameter>> },
    components: { Calendar, Dropdown, InputSwitch, MultiSelect, Textarea },
    emits: ['update:transformation'],
    data() {
        return { descriptor: DataPreparationSimpleDescriptor as any, localTransformation: {} as ITransformation<ITransformationParameter>, v$: useValidate() as any, dirty: false, currentId: 0 }
    },
    validations() {
        if (this.transformation?.type === 'simple') {
            this.setupLocal()

            let validations = this.descriptor[this.localTransformation.name].validations ? this.descriptor[this.localTransformation.name].validations : []
            return { localTransformation: createValidations('localTransformation', validations) }
        }
    },

    mounted() {
        this.setupLocal()
    },
    methods: {
        handleMultiSelectChange(e: Event): void {
            if (e) {
                this.refreshTransfrormation()
            }
        },

        refreshTransfrormation(): void {
            if (this.localTransformation) {
                let pars = this.localTransformation.type === 'simple' ? this.descriptor[this.localTransformation.name].parameters : []
                pars.forEach((item) => {
                    if (item.name == 'columns' && (item.type === 'multiSelect' || item.type === 'dropdown')) {
                        let localTransformationItemArray = this.localTransformation.parameters.filter((x) => x.name == item.name)
                        if (localTransformationItemArray?.length > 0) {
                            let localTransformationItem = localTransformationItemArray[0]

                            if (this.col) {
                                let selectedItem: Array<IDataPreparationColumn> | undefined = this.columns?.filter((x) => x.header == this.col)
                                if (selectedItem && selectedItem.length > 0) {
                                    selectedItem[0].disabled = true
                                    localTransformationItem.value = item.type === 'multiSelect' ? selectedItem : selectedItem[0][item.optionValue]
                                }
                            } else {
                                this.columns?.forEach((e) => (e.disabled = false))
                            }
                        }
                    }
                })
            }
        },
        setupLocal() {
            if (Object.keys(this.localTransformation).length == 0) {
                this.localTransformation = this.transformation ? { ...this.transformation } : ({} as ITransformation<ITransformationParameter>)

                let name = this.transformation && this.transformation.name ? this.transformation.name : ''
                if (name && this.transformation?.type === 'simple') {
                    let pars = JSON.parse(JSON.stringify(this.descriptor[name].parameters))
                    if (this.readOnly) {
                        for (var i = 0; i < pars.length; i++) {
                            let parName = pars[i]['name']
                            for (var j = 0; j < this.localTransformation.parameters.length; j++) {
                                if (this.localTransformation.parameters[j]['name'] == parName) pars[i]['value'] = this.localTransformation.parameters[j]['value']
                            }
                        }
                    }
                    this.localTransformation.parameters = pars
                }

                this.refreshTransfrormation()
            }
        },
        translate(item): [] {
            const items = item.availableOptions
            items.forEach((element) => {
                element.label = this.$t(element.label)
            })

            return items
        }
    },

    watch: {
        localTransformation: {
            handler(newValue) {
                this.localTransformation = newValue
                this.$emit('update:transformation', newValue)
            },
            deep: true
        }
    }
})
